import React from "react";
import { Link } from "react-router-dom";
import EssenceActionsDropdown from "../../Essence/EssenceActionsDropdown";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";

export default function StaffDocumentListItem(props) {
  const validtodate = props.validtodate ? new Date(props.validtodate) : {};
  const validfromdate = props.validfromdate
    ? new Date(props.validfromdate)
    : {};
  const issueddate = props.issueddate ? new Date(props.issueddate) : {};

  let daysValid = 0;
  if (props.validtodate) {
    let dt = new Date();
    daysValid = Math.round((validtodate - dt) / (1000 * 60 * 60 * 24));
  }

  return (
    <>
      <div
        className={`d-flex justify-content-between align-items-center py-4  border-bottom text-dark`}
      >
        <div style={{ wordBreak: "break-all" }} className="m-lg-0 flex-grow-1">
          <div className="row">
            <div className="col-lg-6">
              <div className="small text-muted">
                {props.countryname} {props.typename}
              </div>
              <Link
                className={`mb-1 mt-1 d-block text-dark text-hover-primary`}
                to={`/staff/${props.client}/files/${props.id}/`}
              >
                <i className="fa fa-file-o mr-2"></i>
                {props.label || props.identity}
              </Link>
              <div>
                {props.identity && (
                  <span className="mt-1 text-dark-50">{props.identity}</span>
                )}
              </div>
            </div>
            <div className="col-lg">
              {props.issued && (
                <div className="mt-1 text-dark-50">{props.issued}</div>
              )}
              {props.issueddate && (
                <div className="text-dark-75" title="Дата выпуска">
                  {issueddate.toLocaleDateString()}
                </div>
              )}
            </div>
            <div className="col-lg">
              {props.validfromdate && (
                <div className="text-dark-75" title="Действителен от">
                  <span className="small text-muted w-20px  d-inline-block">
                    с
                  </span>
                  {validfromdate.toLocaleDateString()}
                </div>
              )}

              {props.validtodate && (
                <>
                  <div
                    className={`${
                      daysValid < 60 ? "text-fail" : "text-dark-75"
                    }`}
                    title="Действителен до"
                  >
                    <span className="small text-muted w-20px d-inline-block">
                      по
                    </span>
                    {validtodate.toLocaleDateString()}
                  </div>
                  {daysValid < 60 && (
                    <label className="label label-inline bg-light-danger">
                      {daysValid} дн.
                    </label>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        <div>
          <div className="d-flex align-items-center justify-content-end text-right">
            <EssenceStateLabel
              id={props.id}
              stateCode={props.statetypecode}
              stateLabel={props.statelabel}
              essence="identity"
            />

            <EssenceActionsDropdown
              essence={"identity"}
              key={props.id}
              id={props.id}
              label={props.label}
              onFinish={props.onFinish}
            />

            <button
              onClick={() => props.onEditClick(props)}
              className="btn btn-icon btn-light ml-2"
            >
              <i className="fa fa-pencil"></i>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
